var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBiPersonCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ya16ti7zma)",
    fill: "#7E7E7E"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.904 6a1.875 1.875 0 1 0 0-3.75 1.875 1.875 0 0 0 0 3.75zm1.25-1.875a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0zm2.5 5c0 .625-.625.625-.625.625H.78s-.624 0-.624-.625.625-2.5 3.75-2.5c3.124 0 3.75 1.875 3.75 2.5zm-.625-.003c0-.154-.096-.616-.52-1.04-.407-.407-1.174-.832-2.605-.832-1.43 0-2.197.425-2.605.832-.423.424-.518.886-.52 1.04h6.25z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.063 4.216a.311.311 0 0 1 0 .443L8.188 6.534a.313.313 0 0 1-.443 0l-.937-.938a.313.313 0 0 1 .442-.442l.717.717L9.62 4.216a.313.313 0 0 1 .443 0z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "ya16ti7zma"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(.155)",
    d: "M0 0h12v12H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBiPersonCheck);
export default __webpack_public_path__ + "static/media/bi_person-check.9faf3f45341823825e4989d29f0d40fa.svg";
export { ForwardRef as ReactComponent };